import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import {
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from "antd";
import { BOM } from "../../../services/definedMethod";
import { labelConfig } from "../serviceProvider.config";
import Address from "./address/Address";

const { Text } = Typography;

const ContactInfo = (props) => {
  const {
    form,
    initialValues,
    identifactionTypeData,
    legalOption,
    countryData,
    idType,
    disabledAfterCurrentDate,
    disableDaysBeforeToday,
    isLoading,
    addressList,
    currentCustomerObj,
    addressDetails,
    userData,
  } = props;

  console.log(addressList);

  return (
    <>
      <Form
        className="custom-form"
        layout="vertical"
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
        disabled={true}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.email}
              name="emailAddress"
              rules={[
                {
                  required: true,
                  type: "email",
                },
              ]}
            >
              <Input
                className="of-bold-disable-input"
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(labelConfig.email)}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.mobileNumber}
              name="mobileNo"
              // rules={[
              //   {
              //     required: true,
              //     message: BOM.CheckReqFld(labelConfig.mobileNumber),
              //   },
              // ]}
              rules={[
                () => ({
                  validator(_, value) {
                    console.log(value);
                    if (!value) {
                      return Promise.reject(
                        new Error("Mobile number is required")
                      );
                    }
                    if (value?.length !== 11) {
                      return Promise.reject(
                        new Error("Mobile number must be exactly 11 digits")
                      );
                    }
                    if (!/^[0-9]{11}$/.test(value)) {
                      return Promise.reject(
                        new Error("Mobile number must contain only numbers")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input
                className="of-bold-disable-input"
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(labelConfig.mobileNumber)}
                // style={styles.ofInputFieldNumber}
              />
            </Form.Item>
          </Col>
          {!(legalOption === 2) && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.nationality} name="nationality">
                  <Select
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.nationality,
                      "select"
                    )}
                    options={countryData}
                    className="read-only-select"
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.identifactionType}
                  name="idTypeId"
                >
                  <Select
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.identifactionType,
                      "select"
                    )}
                    options={identifactionTypeData}
                    className="read-only-select"
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          {idType && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.identifactionNo}
                  name="idNo"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.identifactionNo),
                    },
                  ]}
                >
                  <Input
                    className="of-bold-disable-input"
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.identifactionNo
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.issuingDate}
                  name="idIssuingDate"
                  rules={[
                    {
                      required: idType === 2 ? false : true,
                      message: BOM.CheckReqFld(labelConfig.issuingDate),
                    },
                  ]}
                >
                  <DatePicker
                    suffixIcon={<CalendarIcon color="#667085" width={20} />}
                    className="bond-date-picker custom-input of-bold-disable-input"
                    disabledDate={disabledAfterCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.issuingDate,
                      "select"
                    )}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.expiryDate}
                  name="passExpDate"
                  rules={[
                    {
                      required: idType === 2 ? false : true,
                      message: BOM.CheckReqFld(labelConfig.expiryDate),
                    },
                  ]}
                >
                  <DatePicker
                    suffixIcon={<CalendarIcon color="#667085" width={20} />}
                    className="bond-date-picker custom-input of-bold-disable-input"
                    disabledDate={disableDaysBeforeToday}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.expiryDate,
                      "select"
                    )}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
        <Row>
          <div
            style={{
              width: "100%",
              padding: "16px",
            }}
          >
            <Spin spinning={isLoading} tip="Loading..." size="large">
              <Divider orientation="left" orientationMargin="0">
                {/* <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                          {labelConfig.addressInfo}
                        </Title> */}
              </Divider>

              {addressList?.length > 0 && (
                <Space direction="vertical" style={{ width: "100%" }} size={16}>
                  {addressList.map((address) => (
                    <Card
                      key={address.id}
                      bodyStyle={{ padding: "16px 24px" }}
                      style={{
                        borderRadius: "16px",
                        border: "1px solid #E2E8F0",
                        backgroundColor: "#F8FAFC",
                      }}
                    >
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Text
                            strong
                            style={{
                              display: "block",
                              fontSize: "16px",
                              color: "#1A202C",
                              marginBottom: "4px",
                            }}
                          >
                            {address.title}
                          </Text>
                          <Text type="secondary" style={{ color: "#718096" }}>
                            {address.description}
                          </Text>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                </Space>
              )}
            </Spin>
          </div>
        </Row>
      </Form>
      <Address
        currentCustomerObj={currentCustomerObj}
        addressDetails={addressDetails}
        userData={userData}
      />
    </>
  );
};

export default ContactInfo;
